"use strict";
import Splide from "@splidejs/splide";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const genteSlider = document.querySelector(
            ".testimonial__splide.splide"
        );
        if (!genteSlider) return;

        const splide = new Splide(genteSlider, {
            type: "loop",
            perPage: 1,
            autoplay: false,
            interval: 5000,
            speed: 800,
            pauseOnHover: true,
            arrows: true,
            pagination: false,
            gap: "1.5rem",
        });

        splide.mount();
    });
}
